import { Component } from "../../helpers/compiler";

declare let ScrollMagic: any;
declare let TweenMax: any;
declare let Linear: any;
export const ScrollMagicController = new ScrollMagic.Controller();

@Component({ className: 'js-magic-scroll-box' })
export class MagicScrollBoxComponent {
    constructor(private element: HTMLElement) {
        const offset = Number.parseFloat(this.element.getAttribute('data-magic-offset') || '1000');
        const hook = Number.parseFloat(this.element.getAttribute('data-magic-hook') || '0.5');
        const box = this.element.querySelector('.js-magic-scroll-box-item') || this.element;
        const content = this.element.querySelector('.js-magic-scroll-box-content') || this.element;

        this.setScene(offset, hook, box, content)
    }

    private setScene(offset: number, hook: number, box: Element, content: Element) {
        const translationHeight = window.innerHeight * hook;

        // animate sliding box
        new ScrollMagic.Scene({
            triggerElement: this.element,
            triggerHook: hook,
            offset: offset * -1,
            duration: offset,
        })
            .setTween(
                TweenMax.fromTo(
                    box,
                    1,
                    {
                        css: { translateY: offset * -1, top: translationHeight }
                    },
                    {
                        css: { translateY: 0, top: 0 },
                        ease: Linear.easeNone,
                    }
                )
            )
            .setClassToggle(box, 'is-animating')
            .addTo(ScrollMagicController)
        // .addIndicators({
        //     name: "box pos",
        //     colorStart: 'green',
        //     colorEnd: 'green',
        //     colorTrigger: 'green',
        // })

        // fill background
        new ScrollMagic.Scene({
            triggerElement: this.element,
            triggerHook: hook,
            offset: 0,
        })
            .setTween([
                TweenMax.to(
                    box,
                    .5,
                    {
                        css: { width: '100%', height: '100%', right: 0 },
                        ease: Linear.easeInOutQuad,
                    }
                ),
                TweenMax.fromTo(
                    content,
                    .5,
                    {
                        css: { opacity: 0 }
                    },
                    {
                        css: { opacity: 1 },
                        ease: Linear.easeInOut,
                        delay: .5
                    }
                )
            ])
            .reverse(true)
            .addTo(ScrollMagicController)
        // .addIndicators({
        //     name: "box size",
        //     colorStart: 'green',
        //     colorEnd: 'green',
        //     colorTrigger: 'green',
        // })
    }
}
